import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db, auth } from "../firebase";
import { doc, getDoc, collection, addDoc, query, where, getDocs, serverTimestamp } from "firebase/firestore";
import { useAuth } from "../context/AuthContext";

function UserProfilePage() {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [messageText, setMessageText] = useState("");
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [success, setSuccess] = useState(false);
  const [posts, setPosts] = useState([]);
  const [expandedPosts, setExpandedPosts] = useState({});
  const { currentUser } = useAuth();
  const recipientId = userId;
  const [currentUserInfo, setCurrentUserInfo] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      if (userId) {
        const userRef = doc(db, "users", userId);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          setUser(userSnap.data());
        }
      }
      setLoading(false);
    };
    fetchUser();
  }, [userId]);

  useEffect(() => {
    const fetchCurrentUser = async () => {
      if (currentUser) {
        const userRef = doc(db, "users", currentUser.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          setCurrentUserInfo(userSnap.data());
        }
      }
    };
    fetchCurrentUser();
  }, [currentUser]);

  useEffect(() => {
    const fetchPosts = async () => {
      if (!userId) return;
      const q = query(collection(db, "reviews"), where("userId", "==", userId));
      const querySnapshot = await getDocs(q);
      const postsList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      const sortedPosts = postsList.sort((a, b) =>
  b.createdAt?.toDate?.() - a.createdAt?.toDate?.()
);
setPosts(sortedPosts);

    };
    fetchPosts();
  }, [userId]);

  const toggleExpandedPost = (postId) => {
    setExpandedPosts(prev => ({ ...prev, [postId]: !prev[postId] }));
  };

  const sendMessage = async () => {
    if (!messageText.trim() || !currentUser || !recipientId || !currentUserInfo) return;

    const message = {
      from: currentUser.uid,
      to: recipientId,
      message: messageText,
      senderUsername: currentUserInfo.username || "Anonymous",
      direction: "sent",
      timestamp: serverTimestamp(),
      read: false
    };

    try {
      await addDoc(collection(db, "messages"), message);
      setMessageText("");
      setSuccess(true);
    } catch (err) {
      console.error("Error sending message:", err);
      setSuccess(false);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (!user) return <p>User not found.</p>;

  return (
    <div style={{ display: "flex", gap: "30px", padding: "20px" }}>
      {/* Left column with user info and DM button */}
      <div style={{ flex: 1 }}>
        <h2>{user.username}'s Profile</h2>
        <p><strong>Company:</strong> {user.company || "N/A"}</p>
        <p><strong>Location:</strong> {user.city}, {user.state}</p>
        <p><strong>Job Title:</strong> {user.position || "N/A"}</p>
        <p><strong>Status:</strong> {user.employmentStatus || "N/A"}</p>

	
	
       <div>
  {!currentUser ? (
    <button
      onClick={() => navigate("/login")}
      style={{ marginTop: "10px", padding: "6px 12px", cursor: "pointer" }}
    >
      Send a Direct Message
    </button>
    ) : currentUser.uid === recipientId ? (
    <p style={{ color: "gray", marginTop: "10px" }}>
      You can eddit your information in your account page.
    </p>
  ) : (
    <>
      <button
        onClick={() => setShowMessageBox(prev => !prev)}
        style={{ marginTop: "10px", padding: "6px 12px", cursor: "pointer" }}
      >
        {showMessageBox ? "Cancel" : "Send a Direct Message"}
      </button>

      {showMessageBox && (
        <div style={{ marginTop: "10px" }}>
          <textarea
            value={messageText}
            onChange={(e) => setMessageText(e.target.value)}
            placeholder="Type your message..."
            style={{ width: "100%", height: "100px", marginBottom: "10px" }}
          ></textarea>
          <button onClick={sendMessage} style={{ padding: "6px 12px" }}>Send</button>
          {success && <p style={{ color: "green" }}>Message sent!</p>}
        </div>
      )}
    </>
  )}
</div>
</div>

      {/* Right column showing user's posts */}
      <div style={{ flex: 2 }}>
        <h3>Posts by {user.username}</h3>
        {posts.length === 0 ? (
          <p>No posts yet.</p>
        ) : (
          posts.map(post => (
            <div key={post.id} style={{ borderBottom: "1px solid #ccc", paddingBottom: "10px", marginBottom: "10px" }}>
              <h4>{post.company} ({post.city}, {post.state})</h4>
              <p>
  {expandedPosts[post.id] ? post.comments : `${post.comments.slice(0, 150)}`}
  {post.comments.length > 180 && (
    <button
      onClick={() => toggleExpandedPost(post.id)}
      style={{ marginLeft: "10px", border: "none", background: "none", color: "blue", cursor: "pointer" }}
    >
      {expandedPosts[post.id] ? "Show Less" : "Show More"}
    </button>
  )}
</p>

	<p style={{ fontSize: "12px", color: "#666" }}>
  Posted on {post.createdAt?.toDate?.().toLocaleDateString() || "Unknown date"}
</p>


            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default UserProfilePage;
